export default "__VITE_ASSET__EL7TmaWG__"